import './CsvModal.scss';
import { useRef } from 'react';
import { Col, Container, ListGroup, Row } from 'react-bootstrap';
import { CSVLink } from 'react-csv';
import Swal from 'sweetalert2';
import Text from '../../Text/Text';
import CloseModal from '../CloseModal';

function ResultsModal({
  csvFileSuccess,
  csvFileError,
  itemName,
  failedItems,
  successItems,
  isDock,
  isBulkDelete,
}) {
  const csvLinkRef = useRef();
  console.log(isBulkDelete);
  return (
    <Container className="results-modal-upload">
      <Row>
        <Col>{!isDock && <CloseModal close={() => Swal.close()} />}</Col>
      </Row>
      <Row>
        <Col>
          <h1>Results</h1>
        </Col>
      </Row>
      {successItems.length !== 0 && (
        <Row className="mt-5 mb-5">
          <Col>
            <Text as="h1" className="fs-lg fw-semibold">
              {`The following ${itemName} ${isBulkDelete ? 'deleted' : 'uploaded'} successfully:`}
            </Text>
            <ListGroup>
              {successItems.map((item, index) => (
                <ListGroup.Item key={index}>
                  {itemName === 'Assets' ? (
                    isBulkDelete ? (
                      <Text>{item.name}</Text>
                    ) : (
                      <a className="result-success-link" href={`/assets/${item.model?.assetId}`}>
                        {item.model?.hasOwnProperty('name')
                          ? item.model?.name
                          : item.model?.newAssetName}
                      </a>
                    )
                  ) : (
                    <Text>{item.model.name}</Text>
                  )}
                </ListGroup.Item>
              ))}
            </ListGroup>
          </Col>
        </Row>
      )}
      {failedItems.length !== 0 && (
        <Row className="mt-5 mb-5">
          <Col xs={12}>
            <Text as="h1" className="fs-lg fw-semibold">
              {`The following ${itemName} failed to ${isBulkDelete ? 'delete' : 'upload'}:`}
            </Text>
            <ListGroup>
              {failedItems.map((item, index) => (
                <ListGroup.Item key={index}>
                  {isBulkDelete ? <Text>Asset ID: {item.assetId}</Text> : <Text>{item.msg}</Text>}
                </ListGroup.Item>
              ))}
            </ListGroup>
          </Col>
        </Row>
      )}
      <Col xs={12} className="d-flex flex-row justify-content-between">
        {failedItems.length !== 0 && (
          <CSVLink
            className="csv-failed-link"
            ref={csvLinkRef}
            filename={`Failed-${itemName}`}
            headers={csvFileError.headers}
            disabled={failedItems.length === 0}
            data={
              isBulkDelete
                ? failedItems.map((item) => ({
                    assetId: item.assetId || '',
                    msg: item.error,
                  }))
                : failedItems.map((item) => {
                    if (item.model.hasOwnProperty('name')) {
                      return {
                        name: item.model.name,
                        deviceId: item.model.deviceId,
                        errorMessages: item.msg,
                      };
                    }

                    return {
                      newAssetName: item.model.newAssetName,
                      keywords: item.model.keywords,
                      keyValuePairs: item.model.keyValuePairs,
                      existingBeaconDeviceName: item.model.existingBeaconIds,
                      errorMessages: item.model.errorMessages,
                    };
                  })
            }
          >
            Download CSV with failed {itemName}.
          </CSVLink>
        )}
        {successItems.length !== 0 && (
          <CSVLink
            className="csv-success-link"
            ref={csvLinkRef}
            filename={`Success-${itemName}`}
            headers={csvFileSuccess.headers}
            disabled={successItems.length === 0}
            data={
              isBulkDelete
                ? successItems.map((item) => ({
                    name: item.name || '',
                    assetId: item.assetId || '',
                  }))
                : successItems.map((item) => {
                    if (item.model.hasOwnProperty('name')) {
                      return {
                        name: item.model.name,
                        deviceId: item.model.deviceId,
                      };
                    }

                    return {
                      assetId: item.model.assetId,
                      newAssetName: item.model.newAssetName,
                      keywords: item.model.keywords,
                      keyValuePairs: item.model.keyValuePairs,
                      existingBeaconDeviceName: item.model.existingBeaconIds,
                    };
                  })
            }
          >
            Download CSV with successful {itemName}.
          </CSVLink>
        )}
      </Col>
    </Container>
  );
}

export default ResultsModal;
